export function initProductHeroPosition(): void {
  const productHero = document.querySelector<HTMLElement>('.product-hero');
  const headerBlock = document.querySelector<HTMLElement>('.header-block');

  if (!productHero || !headerBlock) return;

  function updateBackgroundPosition(): void {
    const headerHeight = headerBlock.offsetHeight;
    const productHeroRect = productHero.getBoundingClientRect();
    const headerRect = headerBlock.getBoundingClientRect();

    // Calculate the gap from header bottom to product hero top
    const gapFromHeader = headerRect.bottom - productHeroRect.top;

    // The offset should be negative to pull the background up to the header
    // We calculate it based on current breakpoint by checking a measurement
    const offset = Math.round(gapFromHeader - headerHeight);

    // Set CSS variable on the product-hero element
    productHero.style.setProperty('--product-hero-bg-offset', `${offset}px`);
  }

  // Initial calculation
  updateBackgroundPosition();

  // Recalculate on window resize
  window.addEventListener('resize', updateBackgroundPosition);

  // Recalculate on scroll in case header size changes (sticky header, etc.)
  window.addEventListener('scroll', updateBackgroundPosition, { passive: true });
}

// Auto-initialize only on SmeProductPage/Index
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductHeroPosition);
} else {
  initProductHeroPosition();
}
